<template>
  <label class="bodyTextsSmall opacity67">{{ label }}</label>
  <p class="titleIncident opacity87">{{ textValue }}</p>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps({
  value: {
    type: [String, Number],
    required: false
  },
  label: {
    type: String,
    required: true
  },
  suffix: {
    type: String,
    default: ''
  }
})

const textValue = computed(() => {
  if (props.value) {
    return `${props.value} ${props.suffix}`
  } else {
    return '-'
  }
})
</script>

<style scoped>
p {
  line-height: 12px;
}
</style>
